import React from 'react'

import { PageWrapper } from './style'
import { HttpError } from 'Components/Page/HttpError'
import { PATHS } from 'Config/Routing/paths'

const NotAuthorised = ({ history }) => (
  <PageWrapper>
    <HttpError
      code={403}
      title="Access Denied."
      message={
        "Sorry but you don't have permission to access this page\nIf you think this is an error, please contact the support."
      }
      link={PATHS.main.dashboard}
      history={history}
    />
  </PageWrapper>
)

export { NotAuthorised }
